import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import ROUTES from '@src/constants/route';
import { LANGUAGE } from '@src/constants';
import useTopPaidEvent from '@src/hooks/useTopPaidEvent';

const StyledTopPaidEventHeaderBanner = styled('button')({
  display: 'block',
  width: '100%',
  height: '100%',
  padding: 0,
  border: 'none',
  cursor: 'pointer',
  background: 'none',

  img: { width: '100%', height: '100%', objectFit: 'cover' },
});

// Mobile-web header slide for the event; the copy is part of the image.
const TopPaidEventHeaderBanner = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { config } = useTopPaidEvent();
  const bannerSrc =
    i18n.language === LANGUAGE.VN
      ? config.images.mobileHeaderBannerVi
      : config.images.mobileHeaderBannerEn;

  return (
    <StyledTopPaidEventHeaderBanner
      type="button"
      onClick={() => history.push(ROUTES.TOP_PAID_EVENT)}
    >
      <img src={bannerSrc} alt={t('topPaidEventWidgetAlt')} />
    </StyledTopPaidEventHeaderBanner>
  );
};

export default TopPaidEventHeaderBanner;
